export default __webpack_public_path__ + "static/media/lucky-spin-ico.cae66095.svg";